module.exports = __webpack_public_path__ + "img/login.26189a5e.png";